import { useNavigate } from 'react-router-dom';
import { StatusScreen, type StatusAction } from './ui/StatusScreen';

/**
 * A link that goes nowhere: mistyped, or cut off. It used to be a completely empty page
 * (QA 2026-09-24, files-doc-F20). No frame is shared across pages here, so it fills the window.
 * "Go back" only when there is a page of Artwork's behind this one.
 */
export function NotFound() {
  const navigate = useNavigate();
  const actions: StatusAction[] = [{ label: 'All Files', primary: true, onClick: () => navigate('/?view=files') }];
  if ((window.history.state?.idx ?? 0) > 0) actions.push({ label: 'Go back', onClick: () => navigate(-1) });
  return <StatusScreen kind="not-found" page line="The address may be wrong, or the page has moved." actions={actions} />;
}
